exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n#o2-chart-1 {\n\tmin-width: 100% !important;\n}\n\n#o2-chart-1 svg {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\n#o2-chart-1 path, #o2-chart-2 path {\n\tfill: rgb(255, 255, 255);\n\tstroke: rgb(0, 0, 0);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/map/map.component.css
// module id = ../../../../../src/app/map/map.component.css
// module chunks = 0